<template>
  <el-dialog
    :title="$t(`channel.titles.${isAdd ? 'add' : 'editor'}`)"
    :visible.sync="dialogVisible"
    width="30%">
    <el-row>
      <el-form :model="form" v-bind="formRules">
        <el-form-item :label="$t('channel.label.channelName')" prop="channelName">
          <el-input v-model="form.channelName" disabled/>
        </el-form-item>
        <el-form-item
          :label="$t('channel.label.channelCode')"
          prop="channelCode">
          <el-input v-model="form.channelCode" disabled/>
        </el-form-item>
        <el-form-item :label="$t('channel.label.singleMaxLimit')" prop="maxAmount">
          <el-input v-model="form.maxAmount" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.singleMinLimit')" prop="minAmount">
          <el-input v-model="form.minAmount" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.supported')">
<!--          <i v-for="item in checkboxes" :key="item">{{item}}</i>-->

          <el-checkbox-group v-model="checkboxes">
            <el-checkbox v-for="item in form.tripleChannelList"
                         :key="item.id"
                         :label="item.tripleChannel">
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('channel.label.status')" prop="isOpen">
          <el-select v-model="form.isOpen">
            <el-option
              v-for="item in this.statusData"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
<!--      <el-button size="mini" type="warning" @click="handleEmpty()">{{-->
<!--          $t("btns.empty")-->
<!--        }}</el-button>-->
      <el-button size="mini" @click="dialogVisible = false;checkboxes = [];">{{ $t("btns.cancel") }}</el-button>
      <el-button size="mini" type="primary" @click="handleEditor()">{{
          $t("btns.confirm")
        }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { debounce } from "lodash";

export default {
  props: ["statusData", "serviceTypes", "channelTypeList", "channelTypeData"],
  data() {
    return {
      dialogVisible: false,
      isAdd: true,
      checkboxes: [],
      form: {
        channelCode: '',
        channelName: '',
        minAmount: '',
        maxAmount: '',
        isOpen: 0,
        tripleChannelList: {}
      },
      tripleChannelList: {}
    };
  },
  created() {
    this.formRules = {
      ref: "form",
      "label-width": "auto",
      inline: false,
      size: "small",
      rules: {
        channelCode: [
          {
            required: true,
            message: this.$t("channel.rules.channelCode"),
            trigger: "change"
          }
        ],
        channelName: [
          {
            required: true,
            message: this.$t("channel.rules.channelName"),
            trigger: "change"
          }
        ]
      }
    };
    this.handleEditor = debounce(this._handleEditor, 300);
  },
  // watch:{
  //   form:{
  //     handler(val){
  //       if (!this.checkboxes.length){
  //         this.checkboxes = val.tripleChannelList.filter(item=>item.status === 1).map(item=>item.tripleChannel)
  //       }
  //     },
  //     deep: true
  //   },
  // },
  methods: {
    init(row) {
      this.dialogVisible = true;
      this.handleEmpty()
      if (row) {
        this.isAdd = false;
        // 初始化表单数据
        Object.keys(this.form).forEach((key) => {
          this.form[key] = row[key];

          // if (row[key] === 0 || row[key]) {
          //
          // }
        });
        this.form.id = row.id;
        // 初始化checkbox
        if (this.form.tripleChannelList.length > 0) {
          this.tripleChannelList = this.form.tripleChannelList;
          this.checkboxes = this.form.tripleChannelList.filter(item=>item.status === 1).map(item=>item.tripleChannel)
        }
      }
    },

    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        channelCode: "",
        channelName: "",
        minAmount: "",
        maxAmount: "",
        isOpen: "",
        tripleChannelList: this.tripleChannelList
      };
      this.checkboxes = [];
    },
    _handleEditor() {
      if (this.checkboxes.length > 0) {
        let tempArr = [];
        this.checkboxes.forEach(tripleChannel => {
          tempArr.push({ tripleChannel: tripleChannel, status: 1 });
        });
        this.form.tripleChannelList = tempArr;
      } else {
        this.form.tripleChannelList = [];
      }
      this.$refs.form.validate(
        (valid) =>
          valid &&
          this.$emit(this.isAdd ? "doConfAdd" : "doConfUpdate", this.form, () => {
            this.dialogVisible = false;
          })
      );
    }
  }
};
</script>

<style scoped>
 .dialog-footer {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/channeltypemanage/editor.vue